import { getPath } from '@/router/common'

const baseUrl = {
  title: 'GPS设备信息',
  path: 'Maps'
}

export default [
  {
    path: getPath('VehicheTrackTime', baseUrl),
    name: 'VehicheTrackTime',
    component: () => import(/* webpackChunkName: "VehicheTrackTime" */ '@/views/maps/vehicheTrackTime/index.vue'),
    meta: {
      title: '车辆轨迹回放时间范围'
    }
  },
  {
    path: getPath('VehicheTrack', baseUrl),
    name: 'VehicheTrack',
    component: () => import(/* webpackChunkName: "VehicheTrack" */ '@/views/maps/vehicheTrack/index.vue'),
    meta: {
      title: '打开车辆轨迹回放'
    }
  },
  {
    path: getPath('vehiclePositioning', baseUrl),
    name: 'vehiclePositioning',
    component: () => import(/* webpackChunkName: "vehiclePositioning" */ '@/views/maps/vehiclePositioning/index.vue'),
    meta: {
      title: '车辆当前定位'
    }
  },
  {
    path: getPath('GetMapInfoBySN', baseUrl),
    name: 'Maps_GetMapInfoBySN',
    component: () => import(/* webpackChunkName: "Maps_GetMapInfoBySN" */ '@/views/maps/getMapInfoBySN/index.vue'),
    meta: {
      title: 'GPS地图'
    }
  },
  {
    path: getPath('BAddrToEAddrRoute', baseUrl),
    name: 'Maps_BAddrToEAddrRoute',
    component: () => import(/* webpackChunkName: "Maps_BAddrToEAddrRoute" */ '@/views/maps/bAddrToEAddrRoute/index.vue'),
    meta: {
      title: '轨迹运行展示'
    }
  }
]

